import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { api } from "@/lib/api";

const TAIL = [
  { to: "/about", label: "About", id: "nav-link-about" },
  { to: "/faq", label: "FAQ", id: "nav-link-faq" },
];

const navCls = ({ isActive }) =>
  `nav-link text-[12px] uppercase tracking-[0.2em] ${isActive ? "is-active text-[#1A1A1A]" : "text-[#5A626A] hover:text-[#1A1A1A]"}`;

export const Header = () => {
  const { count, setOpen } = useCart();
  const [menu, setMenu] = useState(false);
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const catLinks = cats.map((c) => ({ to: `/category/${c.slug}`, label: c.name, id: `nav-link-category-${c.slug}` }));
  const links = [{ to: "/gallery", label: "Collection", id: "nav-link-gallery" }, ...catLinks, ...TAIL];

  return (
    <header className="sticky top-0 z-40 border-b border-[#E5E0D8]/60 bg-[#FDFBF7]/85 backdrop-blur-md">
      <div className="container-x flex items-center justify-between py-5">
        <Link to="/" data-testid="nav-logo" className="whitespace-nowrap text-[13px] font-light tracking-[0.42em] sm:text-sm">
          LASZLO ABONYI
        </Link>
        <nav className="hidden items-center gap-10 whitespace-nowrap lg:flex">
          <div className="group relative" data-testid="nav-collection-menu">
            <NavLink to="/gallery" data-testid="nav-link-gallery" className={navCls}>Collection</NavLink>
            {catLinks.length > 0 && (
              <div className="invisible absolute left-1/2 top-full z-50 -translate-x-1/2 pt-4 opacity-0 transition-opacity duration-200 group-focus-within:visible group-focus-within:opacity-100 group-hover:visible group-hover:opacity-100">
                <div className="flex min-w-[220px] flex-col gap-4 border border-[#E5E0D8] bg-[#FDFBF7] px-6 py-5 shadow-sm" data-testid="nav-categories-dropdown">
                  <NavLink to="/gallery" end className={navCls} data-testid="nav-link-all-works">All works</NavLink>
                  {catLinks.map((l) => (
                    <NavLink key={l.to} to={l.to} data-testid={l.id} className={navCls}>{l.label}</NavLink>
                  ))}
                </div>
              </div>
            )}
          </div>
          {TAIL.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={l.id} className={navCls}>
              {l.label}
            </NavLink>
          ))}
          <button data-testid="nav-cart-button" onClick={() => setOpen(true)} className="nav-link text-[12px] uppercase tracking-[0.2em]">
            Bag (<span data-testid="nav-cart-count">{count}</span>)
          </button>
        </nav>
        <div className="flex items-center gap-6 lg:hidden">
          <button data-testid="nav-cart-button-mobile" onClick={() => setOpen(true)} className="text-[12px] uppercase tracking-[0.2em]">
            Bag ({count})
          </button>
          <button data-testid="nav-menu-toggle" aria-label="Menu" onClick={() => setMenu((m) => !m)}>
            {menu ? <X size={20} strokeWidth={1.25} /> : <Menu size={20} strokeWidth={1.25} />}
          </button>
        </div>
      </div>
      {menu && (
        <nav className="container-x flex flex-col gap-6 border-t border-[#E5E0D8] py-8 lg:hidden" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`${l.id}-mobile`} onClick={() => setMenu(false)} className="font-display text-3xl font-light">
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
